import { motion } from 'framer-motion';

export const CompanyIntro = () => {
  return (
    <section
      id="intro"
      data-testid="company-intro-section"
      className="bg-white py-24 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-100px' }}
          transition={{ duration: 0.6 }}
          className="grid lg:grid-cols-12 gap-12 lg:gap-20"
        >
          {/* Left Column - Section Label */}
          <div className="lg:col-span-4">
            <p className="text-xs uppercase tracking-[0.2em] text-slate-400 font-semibold mb-4">
              What We Do
            </p>
            <h2
              data-testid="intro-heading"
              className="text-3xl md:text-4xl font-semibold tracking-tight text-slate-900 font-['Manrope'] leading-tight"
            >
              Practical automation for operational complexity
            </h2>
          </div>

          {/* Right Column - Content */}
          <div className="lg:col-span-8">
            <p className="text-lg md:text-xl leading-relaxed text-slate-700 mb-8">
              Pyrtex develops AI automation systems for businesses that manage high volumes of inbound requests, fragmented communication, or processes that require structured supervision.
            </p>
            <p className="text-base leading-relaxed text-slate-600 mb-8">
              We focus on solutions that bring order to intake workflows — helping organizations collect, organize, route, and act on information with less manual effort and more operational consistency.
            </p>
            <p className="text-base leading-relaxed text-slate-600">
              Our approach is designed around real operational contexts: recruitment agencies handling candidate flows, logistics coordinators managing inbound requests, operations teams processing forms and cases, and businesses that need visibility into complex workflows.
            </p>

            {/* Core principles - more credible than vanity stats */}
            <div className="grid sm:grid-cols-3 gap-8 mt-14 pt-10 border-t border-slate-200">
              <div>
                <p className="text-sm font-semibold text-slate-900 mb-2 font-['Manrope']">Process-First Design</p>
                <p className="text-sm text-slate-500 leading-relaxed">Built around your actual workflows, not generic templates</p>
              </div>
              <div>
                <p className="text-sm font-semibold text-slate-900 mb-2 font-['Manrope']">Phased Implementation</p>
                <p className="text-sm text-slate-500 leading-relaxed">Start with a pilot, prove value, then expand</p>
              </div>
              <div>
                <p className="text-sm font-semibold text-slate-900 mb-2 font-['Manrope']">Operational Control</p>
                <p className="text-sm text-slate-500 leading-relaxed">Supervision and visibility baked in from day one</p>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
